import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Gruta de Benagil a partir de Vilamoura · Iate Privado · Morningstar";
const DESC = "Tour privado à Gruta de Benagil a partir da Marina de Vilamoura no iate Morningstar — grupo privado até 18, paragem de mergulho, grutas marinhas e falésias do Algarve.";
const PATH = "/pt/gruta-de-benagil";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.benagilCaveTour;

export const Route = createFileRoute("/pt/gruta-de-benagil")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Gruta de Benagil · Partida de Vilamoura · Algarve",
        title: "Gruta de Benagil a partir de Vilamoura a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Um charter privado da Marina de Vilamoura até à gruta marinha mais fotografada de Portugal — São Rafael, Senhora da Rocha, o Arco do Triunfo e Benagil, com paragem para mergulho e Champagne a bordo.",
        ctaPrimary: "Ver cruzeiros Benagil",
        ctaSecondary: "Planear o meu tour",
      }}
      pageContent={CONTENT.pt}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "gruta de benagil, gruta de benagil vilamoura, passeio gruta benagil, tour gruta benagil, algarve grutas, vilamoura benagil",
      altPath: { en: "/benagil-cave-tour", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Benagil Cave Tour from Vilamoura",
              description: DESC,
              url: URL,
              itinerary: "Vilamoura Marina → São Rafael → Senhora da Rocha → Triumph Arch → Submarine Beach → Benagil Cave → private beach swim → return.",
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Gruta de Benagil", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.pt.faqs)) },
      ],
    }),
});
